import React from "react";
import Formsy from "formsy-react";
import classNames from "classnames";
import ApiHelper from "../../../../../../../lib/UniversalTable/CoreHelpers/ApiHelper";
import {
  isPercentRangeFilter,
  RANGE_FILTER_DISPLAY_FORMAT
} from "../../../../../../../lib/UniversalTable/CoreHelpers/rangeFilterHelpers";
import FormsyComposedNewDateField from "../../../../../../../lib/FormBuilder/FormsyMaterialUI/FormsyComposedNewDateField";
import FormsyComposedNewTextField from "../../../../../../../lib/FormBuilder/FormsyMaterialUI/FormsyComposedNewTextField";
import withTranslations from "../../../../../../../hocs/withTranslations";
import SingleRangeFilterAbstract from "../../../../../../../abstract/SingleRangeFilterAbstract";

@withTranslations
class SingleRangeFilter extends SingleRangeFilterAbstract {
  renderPercentSuffix() {
    return <span className="single-range-input-suffix">%</span>;
  }

  renderRegularInput(field) {
    const { column } = this.props;

    const value = this.getValue(field);
    const label = field === "min" ? "From" : "To";
    const showPercentSuffix = isPercentRangeFilter(column);

    return (
      <div
        className={classNames(
          "single-range-input-text",
          this.getInputClassName(this.getValueExists(field))
        )}
      >
        <FormsyComposedNewTextField
          name={ApiHelper.getColumnAttributeForFiltering(column) + "_" + field}
          label={label}
          value={String(value ?? "")}
          selectTextOnFocus
          disabled={this.props.disabled}
          onChange={next => {
            this.handleChange(field, next);
          }}
          onBlur={() => {
            this.validateValues();
          }}
          endChild={showPercentSuffix ? this.renderPercentSuffix() : null}
        />
      </div>
    );
  }

  renderDatePicker(field) {
    const { column } = this.props;

    const value = this.getValue(field);
    const label = field === "min" ? "From" : "To";

    return (
      <div
        className={classNames(
          "single-range-date-field",
          this.getInputClassName(this.getValueExists(field))
        )}
      >
        <FormsyComposedNewDateField
          name={ApiHelper.getColumnAttributeForFiltering(column) + "_" + field}
          label={label}
          value={String(value ?? "")}
          selectTextOnFocus
          disabled={this.props.disabled}
          onChange={next => {
            this.handleChange(field, next);
          }}
          onBlur={() => {
            this.validateValues();
          }}
          targetFormat={RANGE_FILTER_DISPLAY_FORMAT}
          allowFuture
          formatDatetimeLikeValue
        />
      </div>
    );
  }

  getInputClassName(valueExists) {
    return classNames({
      "is-greyed-out": !valueExists
    });
  }

  render() {
    const { column, translate } = this.props;
    const { errors } = this.state;
    const { label } = column;

    return (
      <div className="filters-item-wrapper range-filter">
        <h4>{label}</h4>
        <Formsy className="inputs-wrapper">
          <div className="field-outer">
            <div className="field-wrapper">
              {ApiHelper.getIsDateRange(column)
                ? this.renderDatePicker("min")
                : this.renderRegularInput("min")}
            </div>
            {errors.min && !ApiHelper.getIsDateRange(column) ? (
              <span className="error-text">{errors.min}</span>
            ) : null}
          </div>
          <div className="field-outer">
            <div className="field-wrapper">
              {ApiHelper.getIsDateRange(column)
                ? this.renderDatePicker("max")
                : this.renderRegularInput("max")}
            </div>
            {errors.max && !ApiHelper.getIsDateRange(column) ? (
              <span className="error-text">{errors.max}</span>
            ) : null}
          </div>
        </Formsy>
        {this.getHasInvalidDateBounds() ? (
          <span className="error-text">
            {translate("this_value_should_be_a_date")}
          </span>
        ) : null}
        {this.getHasDateOutOfAllowedRange() ? (
          <span className="error-text">
            {this.getDateOutOfAllowedRangeMessage(translate)}
          </span>
        ) : null}
        {this.getValueIsInvalid() ? (
          <span className="error-text">
            {translate("Minimal value should not be larger than maximal value")}
          </span>
        ) : null}
      </div>
    );
  }
}

export default SingleRangeFilter;
